/** The refusal texts the demo store sends: the API's own words, so what the page recognises is what it is shown. */
export const DEMO_REFUSALS = {
  grantMissing: (email: string, propertyId: string) => `add ${email} as Viewer on property ${propertyId}`,
  propertyNotFound: (propertyId: string) => `property ${propertyId} not found`,
  ownershipNotProven: (propertyId: string) =>
    `GA4 property ${propertyId} cannot be connected to this account: none of its web data streams is one of this account's websites`,
  alreadyConnected: (propertyId: string) => `GA4 property ${propertyId} is already connected`,
  notConfigured: (setting: string) => `Google Analytics is not configured in this deployment: ${setting} is not set`,
  rangeTooLong: (maxDays: number) => `a traffic query covers at most ${maxDays} days`,
  fromAfterTo: () => "'from' is after 'to'",
} as const
